// extracted by mini-css-extract-plugin
export default {"banner":"Home_banner__7I25b","banner3":"Home_banner3__ZSpXq"};